import { useEffect, useState } from 'react'

import moment from 'moment'
import Image from 'next/image'
import { twMerge } from 'tailwind-merge'

import { useDevice } from 'hooks'

import { Modal } from 'components/v2/Modal'

import { shouldShowSummit } from 'utils/summit'

const SUMMIT_LINK =
	'https://www.sympla.com.br/evento/vittude-summit-2026/2845683?utm_source=website&utm_medium=banner'

const STORAGE_KEYS = {
	home: 'summit_2026_popup_dismissed_home',
	psi: 'summit_2026_popup_dismissed_psi'
}

const EXPIRY_MS = moment.duration(1, 'hour').asMilliseconds()

const isDismissedWithinExpiry = (storageKey) => {
	try {
		const raw = localStorage.getItem(storageKey)
		if (!raw) return false
		const { dismissedAt } = JSON.parse(raw)
		if (!dismissedAt) return false
		return Date.now() - dismissedAt < EXPIRY_MS
	} catch {
		return false
	}
}

const IMAGES = {
	mobile: {
		src: '/static/images/summit/2026/popup-mobile.png',
		width: 1080,
		height: 1350
	},
	tablet: {
		src: '/static/images/summit/2026/popup-tablet.png',
		width: 1080,
		height: 608
	},
	desktop: {
		src: '/static/images/summit/2026/popup-desktop.png',
		width: 1920,
		height: 600
	}
}

export const SummitPopUp = ({ variant = 'home' }) => {
	const [isOpen, setIsOpen] = useState(false)
	const { isMobile, isTablet } = useDevice()
	const storageKey = STORAGE_KEYS[variant] || STORAGE_KEYS.home

	const handleClose = () => {
		setIsOpen(false)
		if (typeof window !== 'undefined') {
			localStorage.setItem(
				storageKey,
				JSON.stringify({ dismissedAt: Date.now() })
			)
		}
	}

	useEffect(() => {
		if (typeof window === 'undefined') return
		if (!isDismissedWithinExpiry(storageKey)) {
			setIsOpen(true)
		}
	}, [storageKey])

	const imageConfig = isMobile
		? IMAGES.mobile
		: isTablet
			? IMAGES.tablet
			: IMAGES.desktop

	if (!shouldShowSummit() || !isOpen) return null

	return (
		<Modal isOpened={isOpen} onclose={handleClose} setIsOpened={handleClose}>
			{() => (
				<div
					className='relative flex flex-col items-end'
					role='dialog'
					aria-modal='true'
					aria-label='Vittude Summit 2026 - Garanta seu lugar'
				>
					<button
						type='button'
						onClick={handleClose}
						className={twMerge(
							'mb-1 flex items-center rounded-full bg-gray-100 px-3 py-1.5',
							'text-xs font-semibold text-white shadow-md transition hover:bg-gray-800',
							'ring-2 ring-white/30'
						)}
						aria-label='Fechar'
					>
						Fechar
					</button>

					<div
						className={twMerge(
							'relative flex max-h-[90vh] max-w-[95vw] items-center justify-center',
							'overflow-hidden rounded-lg'
						)}
					>
						<a
							href={SUMMIT_LINK}
							target='_blank'
							rel='noopener noreferrer'
							className='relative block h-full w-full'
						>
							<Image
								src={imageConfig.src}
								alt='Vittude Summit 2026 - O maior evento de saúde mental corporativa do Brasil. 25 e 26 de março, São Paulo. Garanta seu lugar.'
								width={imageConfig.width}
								height={imageConfig.height}
								className='h-auto max-h-[90vh] w-full object-contain'
								sizes='(max-width: 640px) 1080px, (max-width: 992px) 1080px, 1920px'
							/>
						</a>
					</div>
				</div>
			)}
		</Modal>
	)
}
